import { useCallback } from "react";
import { useHistory } from "react-router";
import useAuth from "../auth";

const useErrorHandler = () => {
  const { isAuthenticated, deleteAuth } = useAuth();
  const history = useHistory();

  const handler = useCallback(
    (error) => {
      const {
        message,
        response: {
          status,
          data: { errors, error: errorCode },
        },
      } = error;

      let href;

      switch (status) {
        case 401:
          if (isAuthenticated) {
            href = "/";
            deleteAuth();
            alert(errors);
          }

          break;
        case 403:
          // A 403 alone doesn't mean the IP gate fired: CanCan denials (e.g.
          // opening a document you can't read) also render 403, with no body.
          // Only the ip_not_allowed error code marks a session the IP gate
          // rejected, which is the only case that should log the user out.
          if (isAuthenticated && errorCode === "ip_not_allowed") {
            href = "/";
            deleteAuth();
            alert(errors.join(" "));
          }

          break;
        default:
          // handle normal errors with some alert or whatever
          // alert('Algo deu errado com sua solicitação. Tente novamente mais tarde ou entre em contato conosco se o problema persistir.')
          if (process.env.NODE_ENV == "development") console.log(error);
      }

      if (href) window.location.href = href;

      return { requestMessage: message, requestErrors: errors };
    },
    [history, deleteAuth]
  );

  return handler;
};

export default useErrorHandler;
